import SocialSecurityInput from "./SocialSecurityInput";

export default SocialSecurityInput;